import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ProductCard from "../../components/ProductCard";
import { selectUsers } from "../users/usersSlice";
import {
    fetchPromoPageProducts,
    selectPromoPageLoading,
    selectPromoPageProducts,
} from "./promoPageSlice";
import "./ProductSection.css";

export default function ProductSection() {
    const dispatch = useDispatch();
    const products = useSelector(selectPromoPageProducts);
    const loading = useSelector(selectPromoPageLoading);
    const { userAccount } = useSelector(selectUsers);

    useEffect(() => {
        const token = localStorage.getItem("clientToken");
        dispatch(fetchPromoPageProducts({ token }));
    }, [dispatch]);

    if (loading === "loading" && products.length === 0) {
        return <div className="loading-container">Loading products...</div>;
    }

    const formatPTS = (str) => {
        return str ? str.toLocaleString() : "";
    };

    const getProductImage = (product) => {
        if (!product || !product.images) return "/placeholder.png";
        const image = product.images.find(
            (img) =>
                (img.objName.includes(".png") || img.objName.includes(".jpeg")) &&
                img.objName.includes("520-0")
        );
        return image
            ? `${process.env.REACT_APP_PRODUCT_URL}/${image.objName}`
            : "/placeholder.png";
    };

    return (
        <div>
            <section className="rewards-section">
                <div className="rewards-section__header">
                    <h2>Make Life in the Kitchen Easier</h2>

                    <button type="button" className="rewards-section__button">
                        Cook Up Something Special
                    </button>
                </div>

                <div className="product-grid">
                    {products[0]?.map((product) => (
                        <ProductCard key={product.id} product={product} uA={userAccount} />
                    ))}
                </div>
            </section>
            <section className="rewards-section rewards-section--featured">
                {products[1]?.map((product) => (
                    <div key={product.id} className="featured-product">
                        <div className="featured-product__image-container">
                            <img
                                src={getProductImage(product)}
                                alt={product.name}
                                className="featured-product__image"
                            />
                        </div>
                        <div className="featured-product__content">
                            <h2 className="featured-product__title">{product.name}</h2>
                            <p className="featured-product__brand">{product.brandName}</p>
                            <div className="featured-product__points">
                                {formatPTS(product.special ? product.specialPoints : product.points)} pts
                            </div>
                            <p className="featured-product__description">
                                {product.longDescription}
                            </p>
                            <button className="featured-product__cta">Start Brewing</button>
                        </div>
                    </div>
                ))}
            </section>
            <section className="rewards-section rewards-section--bedroom">
                <div className="rewards-section__header">
                    <div className="rewards-section__titles">
                        <h2>Take refuge indoors</h2>
                        <p>Support the sleep-in!</p>
                    </div>

                    <button type="button" className="rewards-section__button">
                        Bedroom Essentials
                    </button>
                </div>

                <div className="product-grid">
                    {products[2]?.map((product) => (
                        <ProductCard key={product.id} product={product} uA={userAccount} />
                    ))}
                </div>
            </section>
            <section className="rewards-section rewards-section--warm-up">
                <div className="rewards-section__header">
                    <div className="rewards-section__titles">
                        <h2>Warm up – from the inside!</h2>
                    </div>
                </div>

                <div className="product-grid product-grid--four-col">
                    {products[3]?.map((product) => (
                        <ProductCard key={product.id} product={product} uA={userAccount} />
                    ))}
                </div>
            </section>
            <section className="rewards-section rewards-section--pick-me-up">
                <div className="rewards-section__header">
                    <div className="rewards-section__titles">
                        <h2>Cold Day Pick-me-up</h2>
                    </div>
                    <button type="button" className="rewards-section__button">
                        Brewing selection
                    </button>
                </div>

                <div className="featured-card-container">
                    {products[4]?.map((product) => (
                        <div key={product.id} className="featured-card">
                            <div className="featured-card__image-container">
                                <img
                                    src={getProductImage(product)}
                                    alt={product.name}
                                    className="featured-card__image"
                                />
                            </div>
                            <div className="featured-card__content">
                                <h2 className="featured-card__title">{product.name}</h2>
                                <p className="featured-card__brand">{product.brandName}</p>
                                <div className="featured-card__points">
                                    {formatPTS(
                                        product.special ? product.specialPoints : product.points
                                    )}{" "}
                                    pts
                                </div>
                                <p className="featured-card__description">
                                    {product.longDescription}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
            <section className="rewards-section rewards-section--entertainment">
                <div className="entertainment-container">
                    <div className="entertainment-grid">
                        {products[5]?.map((product) => (
                            <ProductCard key={product.id} product={product} uA={userAccount} />
                        ))}
                    </div>
                    <div className="entertainment-content">
                        <h2 className="entertainment-content__title">
                            Staying in when it’s too cold out?
                        </h2>
                        <p className="entertainment-content__subtitle">
                            Binge, movie or game – we’ve got you covered.
                        </p>
                        <button type="button" className="entertainment-content__button">
                            Entertainment upgrade
                        </button>
                    </div>
                </div>
            </section>
        </div>
    );
}